// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../worklist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../worklist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faxBadge{right:22px !important;bottom:16px !important}", "",{"version":3,"sources":["webpack://./../ui/src/components/SideBar/SideBarButton/AddNewBtn.css"],"names":[],"mappings":"AAAA,UACC,qBAAA,CACA,sBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
